/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react"
import { getRequest } from "utils/request"
import { Box, CircularProgress } from "@material-ui/core"
import logoImg from "../../assets/images/logo-claro.png"
import { useLocation } from "react-router-dom"
import "./style.css"
import { i18n } from "../../translate/i18n"
import { useAuth } from "../../hooks/auth"
import { useModal } from "../../hooks/modal"
import { useNotification } from "hooks/notification"
import TopBar from "components/TopBar"
import omniLogo from "assets/images/favicon.png"
import { OnlineOfflineUserBadge } from "components/OnlineOfflineUserBadge"
import { ImageLoader } from "components/ImageLoader"
import { ModalChangeCurrentCompany } from "./components/ModalChangeCurrentCompany"
import { NotificationsButton } from "./components/NotificationsButton"
import { HeaderRightPane } from "./components/HeaderRightPane"

/* const I18N_STORAGE_KEY = "i18nextLng"

const localLanguage = localStorage.getItem(I18N_STORAGE_KEY) */

export default function Header({ history }) {
  const [loading, setLoading] = useState(false)

  const [companyHaveWhatsappQr, setCompanyHaveWhatsappQr] = useState(false)

  const {
    loadingModal,
    setStatus,
    setDisconnectedModalVisible,
    disconnectedModalVisible,
    ignoreQr,
    reconnect,
  } = useModal()

  const { user, signOut, socket } = useAuth()

  const location = useLocation()

  const {
    addSelectedCompany,
    selectedCompany,
    update,
    setListOptionsCompanies,
    listOptionsCompanies,
    setListCompanies,
    listCompanies,
  } = useNotification()

  const searchCompanies = async () => {
    setLoading(true)
    //BUSCA EMPRESAS DISPONIVEIS PARA O USUARIO
    const userCompaniesResponse = await getRequest(
      `/userscompanies/partners?includeOmni=1`
    )
    if (userCompaniesResponse.success) {
      const companies = userCompaniesResponse.data

      if (!companies.length) {
        return
      }

      const userCompanies = companies.map((company) => ({
        value: company.id,
        label: company.nickName,
        pathLogo: company.pathLogo,
        document: company.document,
        ChannelIds: company.ChannelIds,
      }))

      setListOptionsCompanies(userCompanies)
      setListCompanies(userCompaniesResponse.data)
      //SALVA PRIMEIRA EMPRESA DA LISTA NO CONTEXT
      addSelectedCompany({
        value: Number.parseInt(userCompaniesResponse.data[0].id),
        id: Number.parseInt(userCompaniesResponse.data[0].id),
        label: userCompaniesResponse.data[0].nickName,
        logo: userCompaniesResponse.data[0].pathLogo,
        ...userCompaniesResponse.data[0],
      })

      setLoading(false)
    }
  }

  /* const searchUserMenu = async () => {
    if (selectedCompany.id >= 0) {
      // BUSCA MENU USUARIO
      const menusResponse = await getRequest(
        `/menus?UserTypeId=${user.UserTypeId}&CompanyId=${selectedCompany.id}`
      )
      if (menusResponse.success) {
        let listmenu = []

        // eslint-disable-next-line array-callback-return
        menusResponse.data.map((data) => {
          if (data.type === "H") {
            if (data.MenuId === 16) {
              if (user.password) {
                listmenu.push(data)
              }
            } else {
              listmenu.push(data)
            }
          }
        })

        setMenus(listmenu)
        setLoading(false)
      }
    }
  }

  const handleLogoff = async () => {
    await signOut()
    history.push("/")
  } */

  const handleSelectedCompany = (e) => {
    // ALTERA CONTEXT COM NOVA EMPRESA SELECIONADA
    listCompanies.forEach((data) => {
      if (Number(data.id) === Number(e.value)) {
        addSelectedCompany({
          value: Number.parseInt(e.value),
          id: Number.parseInt(e.value),
          label: data.nickName,
          nickName: data.nickName,
          logo: data.pathLogo,
          trial: data.trial,
          trialLimit: data.trialValidate,
          usersLimit: data.usersLimit,
          dueDay: data.dueDay,
          ticketToShow: data.ticketToShow,
          document: data.document,
        })
      }
    })

    if (location.pathname === `/dashboard/editcompany/${selectedCompany.id}`) {
      if (Number.parseInt(e.value) !== 0) {
        if (
          location.pathname !==
          `/dashboard/editcompany/${Number.parseInt(e.value)}`
        ) {
          history.push(`/dashboard/editcompany/${Number.parseInt(e.value)}`)
        }
      } else {
        history.push("/dashboard")
      }
    }
  }

  useEffect(() => {
    searchCompanies()
  }, [update])

  useEffect(() => {
    const getSockets = async () => {
      if (selectedCompany.id) {
        const { data } = await getRequest(`/companies/${selectedCompany.id}`)

        const index = data.CompanyChannels.findIndex((e) => e.ChannelId === 5)

        if (index >= 0) {
          const { data } = await getRequest(
            `/whatsappcallback/status?CompanyId=${selectedCompany.id}`
          )
          if (!data.connected) {
            socket.emit("create-session", {
              id: selectedCompany.id,
            })
            socket.on("create-session", (res) => setStatus(res))
          }
          setCompanyHaveWhatsappQr(true)
        } else {
          setCompanyHaveWhatsappQr(false)
        }
      }
    }
    getSockets()
  }, [socket, selectedCompany, reconnect])

  const getStatus = async () => {
    if (companyHaveWhatsappQr) {
      if (!loadingModal) {
        try {
          const { data } = await getRequest(
            `/whatsappcallback/status?CompanyId=${selectedCompany.id}`
          )
          if (!data.connected) {
            setDisconnectedModalVisible(true)
          }
        } catch (error) {}
      }
    }
  }

  useEffect(() => {
    if (
      companyHaveWhatsappQr &&
      selectedCompany.id !== 0 &&
      !disconnectedModalVisible &&
      !ignoreQr &&
      !loadingModal
    ) {
      const interval = setInterval(() => {
        getStatus()
      }, 5000)
      return () => clearInterval(interval)
    }
  }, [
    companyHaveWhatsappQr,
    selectedCompany,
    disconnectedModalVisible,
    ignoreQr,
    loadingModal,
  ])

  return (
    <div
      style={{ position: "fixed", maxWidth: "100svw" }}
      className="navbar-custom topnav-navbar"
      data-layout="attach"
    >
      {/* <div className="container-fluid"></div> */}
      <span className="topnav-logo">
        <div className="logo-header">
          <span className="logo-lg">
            <img
              height="45"
              src={logoImg}
              alt=""
              onClick={() => history.push(`../../../../dashboard`)}
              style={{ cursor: "pointer" }}
            />
          </span>
        </div>
      </span>

      <div className="list-unstyled topbar-right-menu float-right mb-0">
        <li className="dropdown notification-list" style={{ height: "70px" }}>
          <div className="area-list-company-header-combo">
            <ImageLoader
              imgUrl={
                selectedCompany.id !== 0 ? selectedCompany.logo : omniLogo
              }
              resourceType="company"
              style={{ borderRadius: selectedCompany.id === 0 && 0 }}
              className="img-avatar-company-header"
              alt="avatar-company"
              whosCalling="Header 532"
            />
            <div>
              <ModalChangeCurrentCompany
                companyList={listOptionsCompanies}
                changeCurrentCompany={handleSelectedCompany}
              />

              <div className="list-company-header-combo"></div>
            </div>
          </div>
        </li>

        {!loading ? (
          <HeaderRightPane />
        ) : (
          <div className="area-loading-header">
            <CircularProgress size={35} />
          </div>
        )}
      </div>
      {user.UserTypeId !== 13 && <TopBar history={history} />}
    </div>
  )
}
